function Wave(props) {
    if (props.up === true) {
        return (
            <img src="/images/wave.png" className="wave" alt="wave"/>
        )

    } else {
        return (
            <img src="/images/waved.png" className="waved" alt="wave"/>
        )
    }
}
export default Wave;